import getLatestSync from '@hooks/siso/getLatestSync';

const useGetLatestSync = () => getLatestSync();

export default useGetLatestSync;
